import {
	AlertTriangle,
	Check,
	Info,
	Lightbulb,
	TriangleAlert,
	XIcon,
} from 'lucide-solid'
import { Button, IconButton, Toast } from '@components'
import { api } from '@here/api'
import { Match, Show, Switch } from 'solid-js'
import { Flex } from 'styled-system/jsx'
import { css } from 'styled-system/css'

export const toaster = Toast.createToaster({
	placement: 'bottom-end',
	overlap: true,
	gap: 16,
	duration: 9000000,
})

export default function () {
	return (
		<>
			<Toast.Toaster toaster={toaster}>
				{(toast) => (
					<Toast.Root
						borderColor={toast().type}
						borderWidth="1px"
						border="solid"
					>
						<Flex
							justifyContent="start"
							alignItems="center"
							gap={2}
							mb={2}
						>
							<Switch>
								<Match when={toast().type === 'error'}>
									<AlertTriangle
										class={css({
											color: 'error',
										})}
										size={20}
									/>
								</Match>
								<Match when={toast().type === 'success'}>
									<Check
										class={css({
											color: 'success',
										})}
										size={20}
									/>
								</Match>
								<Match when={toast().type === 'info'}>
									<Lightbulb
										class={css({
											color: 'info',
										})}
										size={20}
									/>
								</Match>
							</Switch>
							<Toast.Title>{toast().title}</Toast.Title>
						</Flex>
						<Toast.Description>{toast().description}</Toast.Description>
						<Show when={toast().action}>
							<Toast.ActionTrigger
								asChild={(actionProps) => (
									<Button
										{...actionProps()}
										variant="link"
										size="sm"
									>
										Action
									</Button>
								)}
							/>
						</Show>
						<Toast.CloseTrigger
							asChild={(closeProps) => (
								<IconButton
									{...closeProps()}
									size="sm"
									variant="link"
								>
									<XIcon />
								</IconButton>
							)}
						/>
					</Toast.Root>
				)}
			</Toast.Toaster>
		</>
	)
}
